import './App.css';
import FillDiv from './FillDiv';
import ToolBar from './ToolBar';
import Projects from './components/Projects'
import Hero from './Hero';
import { isMobile } from './Hero';
import SideNavTest from './components/SideNavTest';
import { useEffect } from 'react';
function App() {
  useEffect(()=>{
    if(isMobile()){
    const sideBar = document.getElementById("mySidebar");
    sideBar.classList.add('sidebarMobile');
    }

  },[])
  return (
    <>

    <ToolBar showToolBar={false} color={"black"}/>
    <SideNavTest items={[]} ></SideNavTest>
    <Hero/>
    {isMobile()? <div></div> :<></>}
    <FillDiv/>
    <div style={{paddingTop:'50px'}}></div>
    <Projects/>


    </>

  );
}

export default App;
